import React from "react";
import {
  LoaderWrapper,
  ManageTransactionLayout,
  PendingApprovalCard,
  FieldInput,
  FieldDropSide,
  MultiSelectDropdown,
  DatePicker,
  TransactionHistoryTile,
} from "../../../components";
import {
  OPTIONS_DATA_MAPPER,
  required,
  toMultiSelectValue,
  toOptionValuesFromMapper,
  usDateFormat,
  toMultiSelectValueById,
} from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as CoreLogo } from "../../Mapper/MapperHomeContainer/core.svg";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { Formik, Field } from "formik";
import { Form, Button, Image } from "react-bootstrap";
import { isEmpty } from "lodash";
import ExcelImage from "../../../styles/exportimg.PNG";
import Employeepic from "../../../assets/employeePhoto.jpeg";
import Data from "../../../mocks/transactionHistory.json";
const transactionTypes = [
  {
    label: "trans1",
    value: 1,
  },
  {
    label: "trans2",
    value: 2,
  },
];
const History = (props) => {
  return (
    <ManageTransactionLayout layoutHeader="Transaction History">
      <div className="w-100 h-100" style={{ overflow: "hidden" }}>
        <Formik
          initialValues={{}}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            values,
            setErrors,
            ...rest
          }) => {
            const onDaySelected = (fieldName, value) => {
              setFieldValue(fieldName, value);
            };

            return (
              <Form
                autoComplete="off"
                className="mt-10"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <div className="d-flex ">
                  <div className="d-flex ">
                    <div className="d-flex ml-3">
                      <div style={{ position: "relative", display: "flex" }}>
                        <div className="d-flex mr-3 ">
                          <Field
                            size="lg"
                            placeholder="Employee, Plan, Transaction sub type"
                            label="Search"
                            isRequired
                            name="search"
                            type="text"
                            autoComplete="off"
                            value={values["search"]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                        </div>
                        <div className="d-flex ml-3 mr-3 ">
                          <Field
                            isRequired
                            size="sm"
                            label="Transaction Type"
                            name={"transactionType"}
                            // value={toMultiSelectValueById(
                            //   selectedAvailableEmployeeClassifications,
                            //   transactionTypes
                            // )}
                            isMultiSelect
                            popupContent={
                              <MultiSelectDropdown
                                label="Transaction Type"
                                name={"transactionType"}
                                onSelect={(value) =>
                                  setFieldValue("Transaction Type", value)
                                }
                                value={values["Transaction Type"]}
                                options={transactionTypes}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div className="d-flex ml-3 mr-3 ">
                          <Field
                            size="sm"
                            label="Date From"
                            isRequired
                            name={"dateFrom"}
                            value={usDateFormat(values["dateFrom"])}
                            direction="bottom"
                            isDatePicker
                            onClear={() => setFieldValue("dateFrom", "")}
                            //   validate={(value) =>
                            //     ["", undefined, null, "Select One"].includes(
                            //       value
                            //     ) && isEmpty(values["dateFrom"])
                            //       ? "Required"
                            //       : null
                            //   }
                            popupContent={
                              <DatePicker
                                onDayClick={(value) =>
                                  onDaySelected("dateFrom", value)
                                }
                                value={usDateFormat(values["dateFrom"])}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div className="d-flex ml-3 mr-3 ">
                          <Field
                            size="sm"
                            label="Date To"
                            isRequired
                            name={"dateTo"}
                            value={usDateFormat(values["dateTo"])}
                            direction="bottom"
                            isDatePicker
                            onClear={() => setFieldValue("dateTo", "")}
                            //   validate={(value) =>
                            //     ["", undefined, null, "Select One"].includes(
                            //       value
                            //     ) && isEmpty(values["dateFrom"])
                            //       ? "Required"
                            //       : null
                            //   }
                            popupContent={
                              <DatePicker
                                onDayClick={(value) =>
                                  onDaySelected("dateTo", value)
                                }
                                value={usDateFormat(values["dateTo"])}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <Button
                    className=" mt-12 sort-button"
                    variant="secondary"
                    type="submit"
                    style={{
                      marginLeft: "8px",
                      marginTop: "30px",
                    }}
                  >
                    Search
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>

        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex flex-col">
            <div
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#333333",
                paddingTop: "6px",
              }}
            >
              Showing Results
            </div>
            <div
              className="ft-12 grey-text font-weight-500"
              // style={{ paddingTop: "6px" }}
            >
              {10} Records found
            </div>
          </div>
          <div className="d-flex pad-top-10">
            <div className="ft-12 grey-text font-weight-500 marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="transaction-history-table">
          <div className="header-transaction-history w-20">
            <div className="table-header-transaction-history">Participant</div>
            <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
          </div>
          <div className="header-transaction-history w-20">
            <div className="table-header-transaction-history">
              Plan name & ID
            </div>
            <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
          </div>
          <div className="header-transaction-history w-20">
            <div className="table-header-transaction-history">
              Transaction Type
            </div>
            <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
          </div>
          <div className="header-transaction-history w-20">
            <div className="table-header-transaction-history">Amount</div>
            <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
          </div>
          <div className="header-transaction-history w-20">
            <div className="table-header-transaction-history">Updated by</div>
            <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
          </div>
        </div>
        <div className="inner-table-transaction-history">
          {Data.map((e, i) => {
            return <TransactionHistoryTile data={e} />;
          })}
        </div>
        {/* <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      title={column.label}
                      width={column.width}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "date" && dateForm) || renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <ColumnMenu
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div> */}
      </div>
    </ManageTransactionLayout>
  );
};

export default History;
